export default __webpack_public_path__ + "static/media/logo.639920b3.svg";